import React, { useEffect, useState } from 'react';
import LomavisCard1 from '../../../generic/cards/LomavisCard1/LomavisCard1';
import { useTranslate } from '@tolgee/react';
import CustomQuillEditor from '../../../communication/messages/customQuill';
import LomavisButtonToggle1 from '../../../generic/buttons/LomavisButtonToggle1';
import { useDispatch, useSelector } from 'react-redux';
import { setApprovalConfiguration } from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import {
  APPROVAL_TEXT_EDITOR_TARGET_PRIVATE_MESSAGE,
  APPROVAL_TEXT_EDITOR_TARGET_PUBLIC_MESSAGE,
  ApprovalQuillText
} from './approvalQuillText';

const ApprovalMessageCard: React.FC = () => {
  const { t } = useTranslate();
  const [quillEditor, setQuillEditor] = useState(null);
  const [selected, setSelected] = useState('public');
  const emptyDelta = {
    ops: [{ insert: '\n' }]
  };
  const onSelect = (value: string): void => {
    setSelected(value);
    if (value === 'public') {
      quillEditor.setContents(public_message);
    } else {
      quillEditor.setContents(private_message);
    }
  };
  const {
    data: { private_message, public_message }
  } = useSelector((state: any) => state.lomavisPostApproval);

  const dispatch = useDispatch();
  const setMessage = (value: string): void => {
    dispatch(
      setApprovalConfiguration({
        key: selected === 'public' ? 'public_message' : 'private_message',
        value
      })
    );
  };

  // Initialize editor content when messages change
  useEffect(() => {
    if (quillEditor) {
      const content = selected === 'public' ? public_message : private_message;
      quillEditor.setContents(content || emptyDelta);
    }
  }, [selected]);

  useEffect(() => {
    if (quillEditor) {
      // disable all on change listeners
      quillEditor.off('text-change');
      quillEditor.on('text-change', () => {
        setMessage(quillEditor.getContents());
      });
    }
  }, [quillEditor]);

  return (
    <LomavisCard1
      title={t('lomavisPostApproval.approvalMessageCard.title')}
      helpText={t('lomavisPostApproval.approvalMessageCard.description')}
    >
      <div>
        <LomavisButtonToggle1
          buttonLeftFaIconClass="fa-duotone fa-solid fa-message"
          buttonLeftText={t(
            'lomavisPostApproval.approvalMessageCard.publicMessage'
          )}
          buttonLeftValue="public"

          hideRightButton={true}
          buttonRightFaIconClass="fa-duotone fa-solid fa-lock"
          buttonRightText={t(
            'lomavisPostApproval.approvalMessageCard.privateMessage'
          )}
          buttonRightValue="private"
          value={selected}
          onChange={onSelect}
        />

        <div className="mt-3" />
        <div className="border border-secondary rounded">
          <div style={{ display: selected === 'public' ? 'block' : 'none' }}>
            <ApprovalQuillText target={APPROVAL_TEXT_EDITOR_TARGET_PUBLIC_MESSAGE} />
          </div>
          <div style={{ display: selected === 'public' ? 'none' : 'block' }}>
            <ApprovalQuillText target={APPROVAL_TEXT_EDITOR_TARGET_PRIVATE_MESSAGE} />
          </div>
        </div>
      </div>
    </LomavisCard1>
  );
};

export default ApprovalMessageCard;
